<template>
    <div>
        <el-upload :disabled="disabled"
                   style="float:left"
                   ref="upload"
                   :action="uploadUrl"
                   :show-file-list="false"
                   multiple
                   :on-success="success"
                   :on-remove="removeFile"
                   name="file">
                        <el-button :disabled="disabled" slot="trigger" size="small" type="primary">{{$t('common.selectFile')}}</el-button><!--选取文件-->
        </el-upload>
        <div class="fileList">
            <ul>
                <li v-for="doc of DocList">
                    <el-link type="primary" @click="downloadFile(doc)" >{{doc.documentName}}</el-link>
                    <i v-if="!disabled" class="del-btn el-icon-delete pull-right" @click="removeFile(doc)"></i>
                </li>
            </ul>
        </div>
        <div class="imgList">
            <ul>
                <li v-for="(img) of ImgList">
                    <div class="img-container">
                        <el-image style="width: 200px; height: 200px" :src="img.base64 || docIdToUrl(img.tmDocumentId)" :preview-src-list="[img.base64 || docIdToUrl(img.tmDocumentId)]"></el-image>
                        <div class="imgName">
                            <el-link type="primary" @click="downloadFile(img)" >{{img.documentName}}</el-link>
                            <i v-if="!disabled" class="del-btn el-icon-delete pull-right" @click="removeFile(img)"></i>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
	    import reportApi from "@/api/storeFeedback/report";
	    import {fileService} from "@/api/common/file-utils"
	    import {Message} from "element-ui";
	    import commonFun from "@/utils/commonFun";
        import {saveData} from "@/api/quoteByProduct";
        import commonConstants from "@/constants/commonConstants";

	    export default {
		    name: "store-feedback-attachments",
		    props: {
                docList:Array,
                imgList:Array,
                disabled:Boolean,
		    },
		    data() {
			    return {
                    uploadUrl:commonConstants.fileUploadUrl,
                    DocList: commonFun.convertToArray(this.docList),
                    ImgList: commonFun.convertToArray(this.imgList),
			    }
		    },
		    methods: {
                docIdToUrl(id) {
                    return commonConstants.fileDownloadUrl(id);
                },
                downloadFile(doc){
                    fileService.downloadFile(doc);
                },
			    success(file,fileList) {
                    let that = this;
                    file.data.forEach((file,i)=>{
                        let downloadType = file.downloadType;
                        let imgType = ["image/jpeg","image/png","image/bmp","application/x-bmp","image/gif"];
                        if (imgType.includes(downloadType)) {
                            let reader = new FileReader(); //实例化文件读取对象
                            reader.readAsDataURL(fileList.raw);
                            reader.onload = function(ev) { //文件读取成功完成时触发
                                let dataURL = ev.target.result; //获得文件读取成功后的DataURL,也就是base64编码
                                file.base64 = dataURL;
                                that.ImgList.push(file);
                            }
                            // this.imgFiles.push(fileList[i].raw);
                        } else {
                            this.DocList.push(file);
                        }
                    })
			    },
                removeFile(file) {
                    if (file.tmDocumentId != null) {
                        fileService.deleteFile(file.tmDocumentId).then((resp)=>{
                            this.DocList = this.DocList.filter(doc => doc.fullPath != file.fullPath);
                            this.ImgList = this.ImgList.filter(doc => doc.fullPath != file.fullPath);
                        })
                    }else{
                        this.DocList = this.DocList.filter(doc => doc.fullPath != file.fullPath);
                        this.ImgList = this.ImgList.filter(doc => doc.fullPath != file.fullPath);
                    }
                }
		    },
            watch:{
                DocList(value) {
                    this.$emit("update:docList", value);
                },
                ImgList(value) {
                    this.$emit("update:imgList", value);
                }
            }
	    }

</script>
<style>
    .fileList,.imgList{float: left;width: 100%;}
    .fileList>ul>li,.imgList>ul>li{float: left;list-style: none;}
    .fileList>ul>li .del-btn,.imgList>ul>li .del-btn{margin-right: 2em;line-height: 32px;cursor: pointer;}
</style>
